import { render, staticRenderFns } from "./internal-industrial.vue?vue&type=template&id=220db918&scoped=true&"
import script from "./internal-industrial.vue?vue&type=script&lang=js&"
export * from "./internal-industrial.vue?vue&type=script&lang=js&"
import style0 from "./internal-industrial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./internal-industrial.vue?vue&type=style&index=1&id=220db918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220db918",
  null
  
)

export default component.exports